import { CHAT_MESSAGE_VISIBILITY_THRESHOLD, CLASS_CHAT_HISTORY_ID } from "./constants";

export const getChatMessageVisibility = (messageId: string): boolean | null => {
  const historyNode = document.getElementById(CLASS_CHAT_HISTORY_ID);
  const messageNode = historyNode?.querySelector<HTMLElement>(
    `[data-chat-message-id="${messageId}"]`,
  );
  if (!historyNode || !messageNode) return null;

  const historyRect = historyNode.getBoundingClientRect();
  const messageRect = messageNode.getBoundingClientRect();
  if (messageRect.height <= 0) return null;

  const visibleHeight = Math.max(
    0,
    Math.min(historyRect.bottom, messageRect.bottom) - Math.max(historyRect.top, messageRect.top),
  );
  return visibleHeight / messageRect.height >= CHAT_MESSAGE_VISIBILITY_THRESHOLD;
};
